import { render, staticRenderFns } from "./ParentAsinField.vue?vue&type=template&id=be8ca9da&"
import script from "./ParentAsinField.vue?vue&type=script&lang=js&"
export * from "./ParentAsinField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseField: require('/app/components/fields/BaseField.vue').default})
